import { render } from "./UserDeleteAccount.vue?vue&type=template&id=310fd795&scoped=true"
import script from "./UserDeleteAccount.vue?vue&type=script&lang=js"
export * from "./UserDeleteAccount.vue?vue&type=script&lang=js"

import "./UserDeleteAccount.vue?vue&type=style&index=0&id=310fd795&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310fd795"]])

export default __exports__